import React from 'react';
import { Table } from 'reactstrap';
import Select from 'react-select';
import EditableField from './EditableField';
import HelpPopover from './HelpPopover';
import ACCESSIBILITY_FEATS from '../constants/accessibility_feats';
import ACCESS_MODES from '../constants/access_modes';
import { matchesSimpleString, matchesDateString } from '../helpers/Validations';

const valuesFromIds = (opts, ids) => { return (!!ids && !!opts) ? opts.filter(o => ids.includes(o.value)) : null;}

export default class ProjectAccessibilityMetadata extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      accessibility_features: this.getAccessibilityFeatures(),
      access_modes: this.getAccessModes(),
      access_modes_sufficient: this.getAccessModesSufficient(),
    };
  }

  getAccessibilityFeatures() {
    return this.props.accessibility_features || [];
  }

  getAccessModes() {
    return this.props.access_modes || [];
  }

  getAccessModesSufficient() {
    return this.props.access_modes_sufficient || [];
  }

  handleSelectChange(value_object, name) {
    const values = value_object.map((val) => val.value);
    this.setState({ [name]: values });
    const selected = values ? values : [];
    this.props.projectUpdate(name, selected);
  }

  getAccessibilitySummary() {
    return[
      {
        title: 'Accessibility Summary',
        attr: 'accessibility_summary',
        text: this.props.accessibility_summary,
        editTitle: 'Enter an accessibility summary',
        description: <span>
          A brief human-readable description of the accessibility or lack of accessibility in this publication. Adding an accessibility summary is a requirement for discoverable ePub publications.
        </span>,
        textarea: true
      },
    ]
  }

  getAccessibilityFields() {
    return [
      {
        title: 'Accessibility Features',
        attr: 'accessibility_features',
        text: this.props.accessibility_features,
        editTitle: 'Enter the accessibility features present in your ePub.',
        description: 'Listing the accessibility features is a requirement for creating discoverable ePub publications.',
      },
    ];
  }

  getAccessModeFields() {
    return [
      {
        title: 'Access Modes',
        attr: 'access_modes',
        text: this.props.access_modes,
        editTitle: 'Enter the access modes used.',
        description: 'Access modes are the human sensory perceptual systems used to process or perceive the content. Listing the access modes in a publication is a requirement for discoverable ePub publications.',
      },
    ];
  }

  getAccessModeSufficientFields() {
    return [
      {
        title: 'Sufficient Access Modes',
        attr: 'access_modes_sufficient',
        text: this.props.access_modes_sufficient,
        editTitle: 'Enter the sufficient access modes for use.',
        description: 'Sufficient access modes are the minimum human sensory perceptual systems used to process or perceive the content. Listing the sufficient access modes in a publication is a recommendation for discoverable ePub publications.',
      },
    ];
  }

  tableMultiselectRow(field, options, values_processed) {
    return (<tr key={field.attr} id={`${field.attr}-row`}>
      <td className="section-table-head">
        {field.description ? <HelpPopover
          size="sm"
          name={`help-${field.attr}`}
          key={`help-${field.attr}`}
          placement={'right'}
          title={field.title}
        >
          {field.description}
        </HelpPopover> : '' }
        {field.description ? ' ' : ''}{field.title}
      </td>
      <td id={field.attr}>
        <Select
          isMulti
          key={field.attr}
          name={field.attr}
          value={valuesFromIds(options, values_processed)}
          options={options}
          onChange={(value) => this.handleSelectChange(value, field.attr)}
        />
      </td>
    </tr>);
  }

  tableRow(field) {
    return (<tr key={field.attr} id={`${field.attr}-row`}>
      <td className="section-table-head">
        {field.description ? <HelpPopover
          size="sm"
          name={`help-${field.attr}`}
          key={`help-${field.attr}`}
          placement={'right'}
          title={field.title}
        >
          {field.description}
        </HelpPopover> : '' }
        {field.description ? ' ' : ''}{field.title}
      </td>
      <td id={field.attr}>
        <EditableField
          itemRef={field.attr}
          text={field.text}
          title={field.editTitle}
          limit={200}
          update={(id, attr, value) => this.props.projectUpdate(attr, value)}
          validate={field.validation ? field.validation : () => true}
          warning={field.warning ? field.warning : 'Does not match expectations.'}
          allowEmpty={true}
          textarea={!!field.textarea}
        />
      </td>
    </tr>);
  }

  render() {
    return (<div className="section-list" id='project-metadata-extended'>
      <div className="section-header">
        <h2>Accessibility Options</h2>
      </div>
      <Table
        className="section-table"
        responsive
        hover
      >
        <tbody>
          {this.getAccessibilityFields().map(field => this.tableMultiselectRow(field, ACCESSIBILITY_FEATS, this.state.accessibility_features))}
          {this.getAccessModeFields().map(field => this.tableMultiselectRow(field, ACCESS_MODES, this.state.access_modes))}
          {this.getAccessModeSufficientFields().map(field => this.tableMultiselectRow(field, ACCESS_MODES, this.state.access_modes_sufficient))}
          {this.getAccessibilitySummary().map(field => this.tableRow(field))}
        </tbody>
      </Table>
    </div>);
  }
}
